import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import { withModel } from '../../../data-providers/model';
import { isAmazonPaymentAvailable, getAmazonDetails } from './helpers';
import Amazon from './Amazon';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import linkFactory from 'src/client/js/analytics/factory/link';

const enhance = compose(
  withModel,
  mapProps(({ paymentMethods, ...props }) => {
    const url = localiseUrl(props.model.countryModel, '/checkout-v2/amazon');
    return {
      ...props,
      amazonDetails: getAmazonDetails(paymentMethods),
      isAmazonPaymentAvailable: isAmazonPaymentAvailable(paymentMethods),
      authCompleteRedirectUrl: url,
      onClick: linkFactory({
        category: 'Cart',
        action: 'Pay With Amazon',
        label: 'Amazon Pay',
      })
    };
  }),
);

export default enhance(Amazon);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Checkout/Amazon/index.js